import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { masterApi } from "@/lib/api";

export const usePlans = (initial) => {
  const [plans, setPlans] = useState(initial || []);
  useEffect(() => { if (!initial?.length) masterApi.get("/plans").then((r) => setPlans(r.data)).catch(() => {}); }, [initial]);
  return initial?.length ? initial : plans;
};

export const discounted = (price, promo) => {
  if (!promo) return price;
  const off = promo.kind === "percent" ? (price * promo.value) / 100 : promo.value;
  return Math.max(0, Math.round((price - off) * 100) / 100);
};

const PlanCard = ({ p, active, onSelect, current }) => (
  <button type="button" data-testid={`plan-option-${p.key}`} onClick={() => onSelect(p.key)}
    className={`relative text-left rounded-xl border-2 px-3 py-2.5 transition-colors ${active ? "border-[#1D4ED8] bg-blue-50" : "border-slate-200 bg-white hover:border-slate-300"}`}>
    {p.discount > 0 && <span className="absolute -top-2 right-2 text-[10px] font-extrabold bg-emerald-600 text-white rounded-full px-2 py-0.5">Save {p.discount}%</span>}
    <p className="text-xs font-bold text-slate-700 pr-10">{p.label}</p>
    <p className="text-xl font-extrabold font-mono text-slate-900 leading-tight">£{p.price.toFixed(0)}{p.months === 1 && p.price > 0 && <span className="text-xs text-slate-400">/mo</span>}</p>
    <p className="text-[11px] text-slate-500">{p.key === "trial" ? `Free for ${p.days} days` : p.months > 1 ? `£${p.per_month.toFixed(2)}/mo · billed every ${p.months} months` : "Billed monthly"}</p>
    {current && <span data-testid={`plan-current-${p.key}`} className="text-[10px] font-bold text-emerald-700">Current plan</span>}
    {active && <Check className="absolute bottom-2 right-2 w-4 h-4 text-[#1D4ED8]" />}
  </button>
);

export const PlanPicker = ({ plans, value, onChange, includeTrial = false, currentKey }) => (
  <div data-testid="plan-picker" className="grid grid-cols-2 gap-2">
    {plans.filter((p) => includeTrial || p.key !== "trial").map((p) => (
      <PlanCard key={p.key} p={p} active={value === p.key} onSelect={onChange} current={currentKey === p.key} />
    ))}
  </div>
);
